import { gql } from "@apollo/client";

export const GET_WALLET_BALANCE = gql`
query GetWalletBalanceAmount($customerId: ID) {
  GetWalletBalanceAmount(customerID: $customerId) {
    balance
    businessStartDate
    openingBalance
    totalRecharge
    totalCharges
    totalAdjustments
  }
}
`

export const GET_WALLET_TRANSACTION = gql`
query GetWalletTransaction($page: Int, $limit: Int, $filter: String, $sort: orderSort, $from: String, $to: String, $dayRange: String, $awbNumber: String,$customerId: String) {
  getWalletTransaction(page: $page, limit: $limit, filter: $filter, sort: $sort, from: $from, to: $to, dayRange: $dayRange, awb_number: $awbNumber,customerId: $customerId) {
    count
    data {
      txnType
      orderId {
        awb_number
      }
      AWBNo
      transactionId
      credit
      debit
      description
      closingBalance
      credit_debit_flag
      createdAt
    }
  }
}
`